import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import ListRegisterMedicalSupply from "../RegisterMedicalSupply/ListRegisterMedicalSupply";
import SearchRegisterMedicalSupply from "../RegisterMedicalSupply/SearchRegisterMedicalSupply";
import RegisterMedicalSupplyPopup from "../Popup/RegisterMedicalSupplyPopup";
import { transformDate } from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
const RegisterMedicalSupplyIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchMedical({
        ...searchRegisterMedical,
        patientId,
      });
    }
  }, [patientId]);
  const { listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  const searchPatientValidationSchema = Yup.object().shape({
    orderDate: Yup.date()
      .transform(transformDate)
      .nullable(),

    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });
  const {
    initRegisterMedicalSupply,
    searchRegisterMedical,
    handleChangeFormSearchMedical,
    openCreateOrEditMedicalSupplyOrderPopup,
    handleCloseCreateOrEditMedicalSupplyOrderPopup,
    saveOrUpdateRegisterMedicalSupplyOrder,
    handleOpenCreateOrEditMedicalPopup,
    handleDeleteMedicalSupplyOrder,
    handleOpenConfirmDelete,
    openConfirmDeleteMedical,
    resetPopupStore,
    openConfirmMessage,
    handleCloseConfirmMessage,
  } = useStore().patientManagementStore.registerMedicalSupplyStore;
  return (
    <>
      <Formik
        initialValues={searchRegisterMedical}
        validationSchema={searchPatientValidationSchema}
        onSubmit={(values) => {
          handleChangeFormSearchMedical(values);
        }}
        enableReinitialize
      >
        <Form autoComplete="off">
          {/* input search */}
          <SearchRegisterMedicalSupply
            handleOpenCreateOrEditPopupMedical={
              handleOpenCreateOrEditMedicalPopup
            }
          />
          {/* table */}
          <ListRegisterMedicalSupply />
          {openConfirmDeleteMedical && (
            <ConfirmPopup
              open={openConfirmDeleteMedical}
              onClose={() => handleOpenConfirmDelete(null)}
              text="Bạn có chắc chắn muốn hủy thẻ trả trước này không ?"
              onConfirm={handleDeleteMedicalSupplyOrder}
            />
          )}
        </Form>
      </Formik>

      {!!openCreateOrEditMedicalSupplyOrderPopup && (
        <RegisterMedicalSupplyPopup
          open={!!openCreateOrEditMedicalSupplyOrderPopup}
          handleClose={handleCloseCreateOrEditMedicalSupplyOrderPopup}
          onSubmit={saveOrUpdateRegisterMedicalSupplyOrder}
          initRegisterMedicalSupply={{
            ...initRegisterMedicalSupply,
            patientId,
          }}
          listVatPercent={listVatPercent}
          resetPopupStore={resetPopupStore}
        />
      )}

      {openConfirmDeleteMedical && (
        <ConfirmPopup
          open={openConfirmDeleteMedical}
          onClose={() => handleOpenConfirmDelete(null)}
          text="Bạn có chắc chắn muốn hủy thẻ trả trước này không ?"
          onConfirm={handleDeleteMedicalSupplyOrder}
        />
      )}

      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => handleCloseConfirmMessage(null)}
          text={openConfirmMessage}
          hideConfirm
          textClose={"Quay lại"}
          title="Đăng ký thất bại"
        />
      )}
    </>
  );
};

export default memo(observer(RegisterMedicalSupplyIndex));
